<template>
	<div>
		<AppFilter @apply="onFilter" v-if="forceRender" calledFrom='keywords' v-model="filters" @retainValues = "retainFilter" ref="appFilter"/>
	</div>
</template>

<script>
	import AppFilter from "@/components/core/indexNew.vue";
	export default {
		props: {
		},
		beforeMount() {},
		components: {
			AppFilter
		},
		computed: {
            // keywordFilter:{
			// 	set(val){
			// 		this.$store.commit('updateKeywordsFilter',val)
			// 	},
			// 	get(){
			// 		return this.$store.state.keywordsFilter
			// 	}
			// },
			currTab(){
				return this.$store.state.keywordCurrentTab
			}
		},
		watch:{
			currTab(){
				this.forceRender = false
				this.$nextTick(()=>{
					this.forceRender = true
				})
				this.setFilters();
			}
		},
		async mounted() {
			// if(Object.keys(this.$store.state.campaign.advanceFilter).length && this.campaignsFilter.length){
			// 	this.filters = JSON.parse(JSON.stringify(this.campaignsFilter))
			// 	this.$refs["appFilter"].setFilterActive();
			// }
			// else
            {
				this.setFilters();
			}
		},
		methods: {
			retainFilter(){

			},
			onFilter(input) {
				let filters = {};
				for (var i = 0; i < input.length; i++) {
                    filters[input[i].name] = input[i].value;
                }
				filters.advanceSearchType = "keyword";
				let payload = {};
				if(filters["status"]){
					payload.status = filters["status"].code
				}
                if(filters["match"]){
					payload.match = filters["match"].code
				}
                if(filters["bid_status"]){
					payload.bid_status = filters["bid_status"].code
				}
                if(filters["ml_strategy"]){
					payload.ml_strategy = filters["ml_strategy"].code
				}
				this.$store.state.currentPageNumber = 1;
				this.$emit("makeKeywordCallFromAdvFilters",payload)
                // make calls to bring data accordingly below
				// this.$store.commit("campaign/setadvanceFilterAttributes", payload);
				// this.$store.dispatch("campaign/getCampaignList");
			},
			setFilters() {
				this.filters = [];
				// sync case for sp/sb
				if(this.$store.state.keywordCurrentTab=='sync' && this.$route.params.sponsoredType!='sd'){
					this.filters = [
						{
							name: "break",
							type: "break"
						},
						{
							name: "status",
							label: "Status",
							type: "select",
							padding:true,
							placeholder: "Select Status",
							value: [],
							enabled: false,
							values: [
								{
									name: "Enabled",
									code: "Enabled"
								},
								{
									name: "Disabled",
									code: "Disabled"
								}
							]
						},
						{
							name: "break",
							type: "break"
						},
						{
							name: "match",
							label: "Match",
							type: "select",
							placeholder: "Select Match",
							padding:true,
							value: [],
							enabled: false,
							values: [
								{ name: "Broad", code: "Broad" },
								{ name: "Exact", code: "Exact" },
								{ name: "Phrase", code: "Phrase" },
							]
						},
						{
							name: "break",
							type: "break"
						},
						{
							name: "bid_status",
							label: "Bid Status",
							type: "select",
							padding:true,
							placeholder: "Select Bid Status",
							value: [],
							enabled: false,
							values: [
								{
									name: "Enabled",
									code: "Enabled"
								},
								{ name: "Paused", code: "Paused" },
								{ name: "Archived", code: "Archived" },
								{
									name: "Pending",
									code: "Pending"
								},
								{ name: "Disabled", code: "Disabled" }
							]
						},
						{
							name: "break",
							type: "break"
						},
						{
							name: "ml_strategy",
							label: "ML Strategy",
							type: "select",
							padding:true,
							placeholder: "Select ML Strategy",
							value: [],
							enabled: false,
							values: [
								{ name: "Exploration", code: "Fixed_increment" },
								{ name: "Exploration_Expired", code: "Exploration_Expired" },
								{ name: "Manually Managed", code: "manually_managed" },
								{ name: "Optimizing", code: "Optimizing" }
							]
						},
						{
							name: "break",
							type: "break"
						}

					];
				}
				// non-sync case for sp/sb
				else if(this.$store.state.keywordCurrentTab=='non_sync' && this.$route.params.sponsoredType!='sd'){
					this.filters = [
						{
							name: "break",
							type: "break"
						},
						{
							name: "match",
							label: "Match",
							type: "select",
							placeholder: "Select Match",
							padding:true,
							value: [],
							enabled: false,
							values: [
								{ name: "Broad", code: "Broad" },
								{ name: "Exact", code: "Exact" },
								{ name: "Phrase", code: "Phrase" },
							]
						},
						{
							name: "break",
							type: "break"
						}

					];
				}
				// case for sd
				if(this.$route.params.sponsoredType=='sd'){
					this.filters = [
						{
							name: "break",
							type: "break"
						},
						{
							name: "status",
							label: "Status",
							type: "select",
							padding:true,
							placeholder: "Select Status",
							value: [],
							enabled: false,
							values: [
								{
									name: "Enabled",
									code: "Enabled"
								},
								{
									name: "Disabled",
									code: "Disabled"
								}
							]
						},
						{
							name: "break",
							type: "break"
						},
						{
							name: "bid_status",
							label: "Bid Status",
							type: "select",
							padding:true,
							placeholder: "Select Bid Status",
							value: [],
							enabled: false,
							values: [
								{
									name: "Enabled",
									code: "Enabled"
								},
								{ name: "Paused", code: "Paused" },
								{ name: "Archived", code: "Archived" },
								{
									name: "Pending",
									code: "Pending"
								},
								{ name: "Disabled", code: "Disabled" }
							]
						},
						{
							name: "break",
							type: "break"
						},
						{
							name: "ml_strategy",
							label: "ML Strategy",
							type: "select",
							padding:true,
							placeholder: "Select ML Strategy",
							value: [],
							enabled: false,
							values: [
								{ name: "Exploration", code: "Fixed_increment" },
								{ name: "Exploration_Expired", code: "Exploration_Expired" },
								{ name: "Manually Managed", code: "manually_managed" },
								{ name: "Optimizing", code: "Optimizing" }
								// { name: "Manually Managed", code: "manually_managed" }
							]
						},
						{
							name: "break",
							type: "break"
						}

					];
				}
				// this.keywordFilter = JSON.parse(JSON.stringify(this.filters))
			}
		},
		data() {
			return {
				filters: [],
				forceRender:true,
			};
		}
	};
</script>
<style lang="scss">
.multiselect__content-wrapper {
	z-index: 1001;
}
</style>
